import { authContext } from '@staffedupusa/shared-components';
import { useContext } from 'react';
import { useQuery } from 'react-query';

import { notificationsKey } from '@features/notifications';
import { notificationsRoute } from '@features/notifications/api/constants';
import axiosInstance from '@server/axiosInstance';

export const useGetNotifications = () => {
  const { authData } = useContext(authContext);
  const isEnabled = Boolean(authData?.isAuth && authData?.user && !authData?.user.is_admin && !authData?.user.enterprise);
  const { data: notificationsData, isFetched: isNotificationsFetched } =
    useQuery({
      queryKey: [notificationsKey],
      queryFn: () =>
        axiosInstance.get(notificationsRoute).then((res) => res.data),
      enabled: isEnabled,
      refetchInterval: 30000,
      refetchOnWindowFocus: true,
    });
  return { notificationsData, isNotificationsFetched };
};
